import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IMerchant } from "@framework/types";

import { MerchantListItem } from "./item";
import { StyledGrid } from "./styled";

export const MerchantList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IMerchant>
  >("/merchants", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "marketplace", "marketplace.merchants"]} />

      <PageHeader message="pages.marketplace.merchants.title" />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(merchant => (
              <StyledGrid size={{ lg: 4, sm: 6, xs: 12 }} key={merchant.id}>
                <MerchantListItem merchant={merchant} />
              </StyledGrid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
